import React from 'react'
import PropTypes from 'prop-types'
import Pattern from '@mui/icons-material/Pattern'

const PatternIcon = ({ height, width, ...more }) => {
	
	return (
		<Pattern
			height={height}
			width={width}
			{...more}
		/>
	)
}

PatternIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default PatternIcon
